import { put, call, takeLatest, select, all } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import totemAPI from '../../api/totem';
import { Creators as CreditCardCreators } from '../../reducers/creditCard';
import { Types, Creators as TotemCreators } from '../../reducers/totem';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* getOrder({ hash }) {
  try {
    const token = yield select(getToken);
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const order = yield call(customerAPI.orderInformations, hash, '', token, siteId);
    const payments = yield call(totemAPI.getOrder, hash, siteId);
    const creditCards = {};

    if (!payments || !payments.length) {
      throw 'Pedido não possui pagamentos cadatrados.';
    }

    yield all(
      payments.map((item, i) =>
        put(
          CreditCardCreators.addCreditCardSuccess({
            creditCard: {
              id: item.sequencia,
              sequencia: i + 1,
              filial: item.filial.id,
              titular: '',
              numero: '',
              validade: '',
              seguranca: '',
              parcela: item.parcelas[0].numeroParcelas,
              valor: item.valorTotal,
              flag: '',
              installment: { parcelas: item.parcelas },
              updateAt: new Date().getTime(),
              firstLoad: true,
            },
            totalPending: 0,
          })
        )
      )
    );

    yield put(
      TotemCreators.getOrderSuccess({ order: { ...order, formaPagamento: payments[0].id, payments: creditCards } })
    );
  } catch (error) {
    yield put(TotemCreators.getOrderError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_ORDER_REQUEST, getOrder);
}
